export function getRandomIndex(data) {
  return Math.floor(Math.random() * data.length);
}
